export const productMightHaveVariants = (product) => Boolean(product?.hasVariants);

export const productHasTreeChildren = (product) => Boolean(
  product?.variants?.length || productMightHaveVariants(product),
);

export const shouldLoadProductVariants = (product) => Boolean(
  productMightHaveVariants(product) && !product?.variants?.length,
);

export const syncProductHasVariants = (product) => {
  // Keep Redux in sync after local variants mutations — tree UI reads hasVariants, not variants.length.
  // eslint-disable-next-line no-param-reassign
  product.hasVariants = !!(product.variants?.length);
};
